// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, contactUs } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitSubmitContactUsApi = createAsyncThunk(
  "hitSubmitContactUsApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          //Authorization: `${localStorage.getItem("professionalToken") ? localStorage.getItem("professionalToken") : localStorage.getItem("clientToken")}`,
        }
      };
      const url = ApiBaseUrl + contactUs;
      const response = await axios.post(url,payload, config);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message || "Something went wrong. Please try again.";
      toast.error(message);
      throw error?.response?.data || { status: false, message };
    }
  }
);

const ContactUsSlice = createSlice({
  name: "contactUsReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearContactUsData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitSubmitContactUsApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitSubmitContactUsApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitSubmitContactUsApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearContactUsDataclearContactUsData } = ContactUsSlice.actions;
export default ContactUsSlice.reducer;